<pf-result [resultProps]="completedProps" [hideHomeButton]="true">
    <pf-text type="description"
        >Thank you for entering all information.</pf-text
    >
    <pf-text type="description">You may now close this page.</pf-text>
</pf-result>
